
export const getWorkPlaceTypeWork = (typeWork) => {
    try {
        let text = ''

        if (typeWork) {
            if (typeWork === 'start') {
                text = 'Початок робочого дня'
            } else if (typeWork === 'end') {
                text = 'Закінчення робочого дня'
            }
        }

        return text
    } catch (e) {
        
    }
}